/* LinksRenderer.js */

"use strict";
const _ = require("lodash");

class LinksRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("links-column");
        this._rootElem.component = this._model;

        this._viewConfigIcon = document.createElement("actionable-icon-gl");
        this._viewConfigIcon.dataset.icon = "configdrift.view_more";
        this._viewConfigIcon.setAttribute("title", "Query Results");

        this._registerListeners();
        this.render();
    }

    /* ******************************************
    /* START PRIVATE COMPONENT RENDERER METHODS
    /* ****************************************** */
    _shutdown() {
        let promiseAll = [];
        if (this._model._modalUserFeedback && !_.isEmpty(this._model._modalUserFeedback._veil)) {
            if (this._model._modalUserFeedback._veil.content.constructor.name !== "RunNowComponent") {
                promiseAll = [this._model._modalUserFeedback.hideDisplayed()];
            }
        }
        return Promise.all(promiseAll).then(() => {
            this._unregisterListeners();
            this._viewConfigIcon.remove();
            this._viewConfigIcon = undefined;
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            return Promise.resolve();
        });
    }

    _registerListeners() {
        this._viewConfigIcon.addEventListener("click", (this._onClickViewConfigIcon = this._onClickViewConfigIcon.bind(this)));
        this._model.on("LinksAdhoc", (this._onLinks = this._onLinks.bind(this)));
        this._model.on("QueryViewOpen", (this._queryViewOpen = _.debounce(this._queryViewOpen.bind(this), 2000)));
    }

    _unregisterListeners() {
        this._viewConfigIcon.removeEventListener("click", this._onClickViewConfigIcon);
        this._model.removeAllListeners("LinksAdhoc");
        this._model.removeAllListeners("QueryViewOpen");
    }

    _onClickViewConfigIcon(e) {
        e.preventDefault();
        this._viewConfigIcon.setDisabled(true);
        this._model.viewConfiguration();
    }

    /* *****************************************
    /* END PRIVATE COMPONENT RENDERER METHODS
    /* START PUBLIC COMPONENT RENDERER METHODS
    /* ***************************************** */
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        this._setIcons(this._model.isEnabled());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /* *****************************************
    /* END COMPONENT RENDERER METHODS
    /* START HANDLER METHODS
    /* ***************************************** */

    _onLinks(newVal) {
        this._model.setValue(newVal);
        this._setIcons(this._model.isEnabled());
    }

    _queryViewOpen() {
        this._viewConfigIcon.setDisabled(false);
    }

    /* *****************************************
    /* END HANDLER METHODS
    /* START PRIVATE API METHODS
    /* ***************************************** */

    _setIcons(newVal) {
        this._rootElem.innerHTML = "";
        this._rootElem.appendChild(this._viewConfigIcon);
        this._viewConfigIcon.setDisabled(!newVal);
    }

    /* *****************************************
    /* END PRIVATE API METHODS
    /* ***************************************** */
}

module.exports = LinksRenderer;
